import type {
  Marker,
  MarkerImage,
  MarkerLine,
  MarkerPin,
  MarkerPolygon,
  MarkerSurface,
  MarkerText,
} from 'minerva-plugin-api';

export const isMarkerPin = (marker: Marker): marker is MarkerPin =>
  Boolean('x' in marker && 'y' in marker && marker.type === 'pin');

export const isMarkerSurface = (marker: Marker): marker is MarkerSurface =>
  Boolean('width' in marker && marker?.width && marker?.height && marker.type === 'surface');

export const isMarkerLine = (marker: Marker): marker is MarkerLine =>
  Boolean(
    'start' in marker && 'end' in marker && marker?.start && marker?.end && marker.type === 'line',
  );

export const isMarkerPolygon = (marker: Marker): marker is MarkerPolygon =>
  marker.type === 'polygon';

export const isMarkerText = (marker: Marker): marker is MarkerText => marker.type === 'text';

export const isMarkerImage = (marker: Marker): marker is MarkerImage => marker.type === 'image';
